export const isServiceDomain = (url: string) => {
  try {
    const urlInstance = new URL(url);
    const {origin} = urlInstance;

    // phase를 제외한 서브 도메인으로 체크하는 이유는 cbt환경에서 리얼 주소가 올 경우도 있기 때문이다.
    const SERVICE_DOMAIN_REGX = /^(https?:\/\/).*?(digitalcard|student-id|employee-id).*?\.kakao\.com/;
    return SERVICE_DOMAIN_REGX.test(origin);
  } catch {
    return false;
  }
};
